import Divider from '@/components/Divider'
import LiveProduct from '@components/LiveProduct'

interface Props {
  product: any;
}

const PinProduct = ({ product = {} }: Props) => {
  return product
    ? (
      <>
        <LiveProduct product={product} isPinned />
        <Divider />
      </>
      )
    : null
}

export default PinProduct
